module.exports = __webpack_public_path__ + "img/Neil_Solomons.f2c060bc.png";